<template>
  <div class="my-4">
    <div class="hr"></div>
    <div class="text-xs-center" style="margin: -13px">
      <a
        class="text btn-advanced"
        href="javascript:void(0);"
        style="position: relative"
        @click="onShowAdvance"
      >
        {{ $t('Advanced') }}
        <i class="fa" :class="{ 'fa-angle-down': !isShow, 'fa-angle-up': isShow }" />
      </a>
    </div>
    <div v-show="isShow" class="mt-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    onShowAdvance() {
      this.isShow = !this.isShow
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ToggleAdvance.vue